import { useCallback } from "react";
import { useEventsApi } from "./useEventsApi";
import { config } from "../config";
import type { EventAuditLogListResponse } from "../shared/eventAuditLog";

export const useEventAuditLogApi = () => {
  const { callApi } = useEventsApi();

  const fetchAuditLogPage = useCallback(
    async (page: number, pageSize: number) => {
      const url = new URL(`${config.apiUrl}/api/event-audit-log/`);
      url.searchParams.set("page", String(page));
      url.searchParams.set("page_size", String(pageSize));
      url.searchParams.set("ordering", "-created_at");
      return callApi(url.toString(), "GET") as Promise<EventAuditLogListResponse>;
    },
    [callApi]
  );

  return { fetchAuditLogPage };
};
